import Vue from 'vue';
import Router from "vue-router";
import VueSocketIO from 'vue-socket.io';
import Login from "../views/account/login.vue";
import ForgotPassword from "../views/account/forgot-password.vue";
import Dashboard from "../views/dashboard.vue";
import OrderList from "../views/orders/list.vue";
import Order from "../views/orders/main.vue";
import VendorList from "../views/restaurant/list.vue";
import VendorAdd from "../views/restaurant/add.vue";
import VendorDetails from "../views/restaurant/details.vue";
import CustomerList from "../views/customer/list.vue";
import CustomerCreditList from "../views/customer/creditlist.vue";
import CustomerCreditDetail from "../views/customer/credit-detail.vue";
import AlertList from "../views/alert/list.vue"
import DealList from "../views/deal/list.vue"
import SupplierList from "../views/supplier/list.vue"
import PurchasingPriceList from "../views/supplier/purchasing-price-list.vue"
import SupplierAdd from "../views/supplier/add.vue";
import SupplierEdit from "../views/supplier/edit-supplier.vue";

import ContactsList from "../views/contacts/list.vue";
import ContactAdd from "../views/contacts/add.vue";
import ContactEdit from "../views/contacts/edit-contacts.vue";

import PurchasingPrices from "../views/supplier/purchasing-prices.vue";
import CustomerDetails from "../views/customer/details.vue";
import DriverList from "../views/driver/list";
import DriverAdd from "../views/driver/add";
import DriverDetails from "../views/driver/details";
import CountryList from "../views/location/list";
import StateList from "../views/location/state-list";
import CityList from "../views/location/city-list";
import PostalList from "../views/postal_code/list";
import PostalCodeAdd from "../views/postal_code/add";
import PostalCodeEdit from "../views/postal_code/edit";
import DeliveryList from "../views/delivery_zone/list";
import DeliveryAdd from "../views/delivery_zone/add";
import DeliveryEdit from "../views/delivery_zone/edit-delivery-zone";
import CouponList from "../views/coupon/list";
import CouponAdd from "../views/coupon/add";
import CouponEdit from "../views/coupon/edit";
import BannerList from "../views/banner/list";
import BannerAdd from "../views/banner/add-banner";
import BannerEdit from "../views/banner/edit-banner";
import CategoryList from "../views/category/list";
import CategoryAdd from "../views/category/add";
import CategoryEdit from "../views/category/edit";
import FaqList from '../views/faq/list';
import FaqAdd from '../views/faq/add';
import FaqEdit from '../views/faq/edit';
import SystemList from '../views/system/list';
import CsvLogs from '../views/csv/log-list';
// import CuisinesList from '../views/cuisines/list';
// import CuisinesAdd from '../views/cuisines/add';
// import CuisinesEdit from '../views/cuisines/edit';
import Configuration from '../views/settings/configurations';
import Themes from '../views/settings/themes';
import EagleView from '../views/eagle-view/list';
import ContentPage from '../views/content-page/list';
import Reports from '../views/reports/list';
import Terminology from '../views/settings/terminology';
// import AddTerminology from '../views/settings/add-terminology';
import Invoice from '../views/orders/invoice';
import VendorFinance from "../views/finance/vendor";
import VendorFinanceMonth from '../views/finance/vendor-finance-month';
import VendorFinanceList from '../views/finance/vendor-finance-list';
import RestaurantFinance from '../views/finance/restaurant/restaurant-finance';
import RestaurantFinanceTransaction from '../views/finance/restaurant/restaurant-transaction';
import DriverDashboard from '../views/driver/dashboard';
import DriverFinance from '../views/finance/driver';
import DriverFinanceDetail from '../views/finance/driver/driver-finance-detail';
import DriverFinanceMonth from '../views/finance/driver/driver-finance-month';
import DriverTransaction from '../views/finance/driver/driver-transaction';
import Profile from '../views/profile/subscription_info';
import UserAccess from '../views/settings/user-access/user-list';
import UserAccessAdd from '../views/settings/user-access/add-user';
import UserAccessEdit from '../views/settings/user-access/edit-user';
import UserAccessPermission from '../views/settings/user-access/user-permission';

import Catalog from '../views/restaurant/catalog.vue';
import ChangePassword from '../views/profile/change-password.vue';
import DiscountList from '../views/discount/discount-list.vue';
import DiscountAdd from '../views/discount/add.vue';
import DiscountEdit from '../views/discount/edit.vue';
import BusinessProfile from '../views/profile/business-profile.vue';
import SubVendorProfile from '../views/restaurant/profile';
// import TimeSlot from '../views/timeslot/timeslots.vue';
// import SellingTimeSlot from '../views/timeslot/selling-timeslot.vue';
import Reviews from '../views/reviews/list.vue';
import Category from '../views/restaurant/category.vue';
import SalesReport from '../views/reports/sales_report.vue';
import ItemReport from '../views/reports/item_report.vue';
import CustomerReport from '../views/reports/customer_report.vue';
import TotalSaleEarning from '../views/reports/total_sales_earning.vue';
import TaxReport from '../views/reports/tax_report.vue';
import DriverReport from '../views/reports/driver_report';
import InactiveCustomerReport from '../views/reports/inactive_customer_report';
import CODOnlineOrderReport from '../views/reports/cod_online_order_report';
import AvgRatingReport from '../views/reports/avg_rating_report';
import PromoCodeReport from '../views/reports/promo_code_report';
import DriverReportDetailsReport from '../views/reports/driver_report_details';
import AppLayoutSetting from '../views/settings/app-layout-setting';
import AddCustomization from '../views/restaurant/add-customization';
import AddSubCustomization from '../views/restaurant/add-sub-customization';
import AddContentPage from '../views/content-page/add';
import EditContentPage from '../views/content-page/edit';
import ViewContentPage from '../views/content-page/view-page';
import config from '../config';
import { orderService } from '../services';
import OperationTime from '../views/restaurant/operation-time';
import VendorCategory from '../views/restaurant/vendor-category';
import VendorDiscount from '../views/restaurant/vendor-discount';
import VendorProfile from '../views/restaurant/vendor-profile';
import VendorRating from '../views/restaurant/vendor-rating';
import Signup from "../views/account/signup.vue";
import HelpList from '../views/help/list';
import { menuItems } from '../components/menu';
import WhatsNew from '../views/whatsnew/whats-new';
import { error_message } from '../Helper/helper';
import SubVendorSignup from "../views/account/sub-vendor-signup.vue";
import ClientList from '../views/client/list';
import ClientAdd from '../views/client/add';
import ClientEdit from '../views/client/edit';
import CurrencyList from '../views/currency/list';
import ChangeLog from '../views/change-log';
import VendorRatingReviewReport from '../views/reports/vendor_rating_review_report';
import DriverRatingReviewReport from '../views/reports/driver_rating_review_report';
import SubCategoryList from '../views/subcategory/list';
import SubCategoryAdd from '../views/subcategory/add';
import SubCategoryEdit from '../views/subcategory/sub-category-edit';
import CustomerAdd from '../views/customer/add';
import ProductList from '../views/product/list';
import ProductAdd from '../views/product/add.vue';
import AlertAdd from '../views/alert/add.vue';
import DealAdd from '../views/deal/add.vue';
import ProductEdit from '../views/product/edit-product';
import AlertEdit from '../views/alert/alert-edit.vue';
import DealEdit from '../views/deal/deal-edit.vue';
import SubProductList from '../views/subproduct/list';
import SubProductAdd from '../views/subproduct/add';
import SubProductOrder from '../views/subproduct/sub-product-order-list';
import SubProductEdit from '../views/subproduct/sub-product-edit';
import SubScriptionList from '../views/subscription/list';
import SubscriptionProductList from '../views/subscription-product/list';
import productBrandList from '../views/product-brand/list';
import ProductBrandAdd from '../views/product-brand/add';
import ProductBrandEdit from '../views/product-brand/edit-brand';
import FaqCategoryList from '../views/faq-category/list';
import FaqCategorAdd from '../views/faq-category/add';
import FaqCategorEdit from '../views/faq-category/edit-faq-category';
import TimeSlotList from '../views/time-slot/list';
import TimeSlotAdd from '../views/time-slot/add';
import TimeSlotEdit from '../views/time-slot/edit-time-slot';
import AttributeList from '../views/attribute/list';
import AttributeAdd from '../views/attribute/add';
import AttributeEdit from '../views/attribute/edit-attribute';
import OrderAdd from '../views/orders/add';
import OrderEdit from '../views/orders/edit-order';
import InvoiceList from '../views/invoices/invoice-list.vue';
import CustomerCreditReport from '../views/reports/customer_credit_report.vue';
import PopularSearchList from '../views/popular-search/list';
import PopularSearchAdd from '../views/popular-search/add';
import PopularSearchEdit from '../views/popular-search/popular-search-edit';

import producerCompanyList from '../views/producer-company/list';
import producerCompanyAdd from '../views/producer-company/add';
import producerCompanyEdit from '../views/producer-company/edit-producer-company';

import producerBrandList from '../views/producer-brand/list';
import producerBrandAdd from '../views/producer-brand/add';
import producerBrandEdit from '../views/producer-brand/edit-producer-brand';

Vue.use(Router);

const urls = menuItems.reduce((m,i)=> i.subItems?m.concat(i.subItems):m, [])

const base = config.base_folder;

const vendorRoutes = [
  {
    path: base+'login',
    name: 'login',
    component: () => import('../views/account/login.vue')
  },
  {
    path: base+'signup',
    name: 'signup',
    component: Signup
  },
  {
    path: base+'dashboard',
    name: 'dashboard',
    component: Dashboard
  },
  {
    path: base+'orders/list',
    name: 'orders-list',
    component: Order
  },
  {
    path: base+'orders/edit/:order_id',
    name: 'edit-order',
    component: OrderEdit,
    access: true
  },
  {
    path: base+'vendors',
    name: 'vendor-list',
    component: VendorList
  },
  {
    path: base+'vendors/add',
    name: 'vendor-add',
    component: VendorAdd
  },
  {
    path: base+'vendors/details/:restaurant_id',
    name: 'vendor-detail',
    component: VendorDetails
  },
  {
    path: base+'vendors/catalog/:restaurant_id',
    name: 'vendor-catalog',
    component: Catalog
  },
  {
    path: base+'vendors/add-customization/:menu_item_id',
    name: 'vendor-add-customization',
    component: AddCustomization
  },
  {
    path: base+'vendors/add-sub-customization/:menu_item_selection_id',
    name: 'vendor-add-sub-customization',
    component: AddSubCustomization
  },
  {
    path: base+'customer',
    name: 'customer-list',
    component: CustomerList
  },
  {
    path: base+'customer/details/:user_id',
    name: 'customer-detail',
    component: CustomerDetails
  },
  {
    path: base+'customer-credit',
    name: 'customer-credit-list',
    component: CustomerCreditList
  },
  {
    path: base+'customer-credit-detail/:user_id',
    name: 'customer-credit-detail',
    component: CustomerCreditDetail,
    access: true
  },
  
  {
    path: base+'driver/dashboard',
    name: 'driver-dashboard',
    component: DriverDashboard
  },
  {
    path: base+'driver',
    name: 'driver-list',
    component: DriverList
  },
  {
    path: base+'driver/add',
    name: 'driver-add',
    component: DriverAdd
  },
  {
    path: base+'driver/details/:driver_id',
    name: 'driver-details',
    component: DriverDetails
  },
  {
    path: base+'location',
    name: 'country-list',
    component: CountryList
  },
  {
    path: base+'location/state-list/:country_id',
    name: 'state-list',
    component: StateList
  },
  {
    path: base+'location/city-list/:state_id',
    name: 'city-list',
    component: CityList
  },
  {
    path: base+'postal_codes',
    name: 'postal-list',
    component: PostalList
  },
  {
    path: base+'postal_code/add',
    name: 'postal-code-add',
    component: PostalCodeAdd,
    access: true
  },
  {
    path: base+'postal_code/edit/:id',
    name: 'postal-code-edit',
    component: PostalCodeEdit,
    access: true
  },
  {
    path: base+'delivery_zone',
    name: 'list',
    component: DeliveryList
  },
  {
    path: base+'delivery_zone/add',
    name: 'delivery-zone-add',
    component: DeliveryAdd
  },
  {
    path: base+'delivery_zone/edit/:id',
    name: 'delivery-zone-edit',
    component: DeliveryEdit
  },
  {
    path: base+'coupon',
    name: 'coupon-list',
    component: CouponList
  },
  {
    path: base+'coupon/add',
    name: 'coupon-add',
    component: CouponAdd
  },
  {
    path: base+'coupon/edit/:id',
    name: 'coupon-edit',
    component: CouponEdit
  },
  {
    path: base+'banner',
    name: 'banner-list',
    component: BannerList
  },
  {
    path: base+'banner/add',
    name: 'banner-add',
    component: BannerAdd
  },
  {
    path: base+'banner/edit/:id',
    name: 'banner-edit',
    component: BannerEdit
  },
  {
    path: base+'finance/driver',
    name: 'driver',
    component: DriverFinance
  },
  {
    path: base+'finance/driver/month/:month',
    name: 'driver-finance-month',
    component: DriverFinanceMonth
  },
  {
    path: base+'finance/driver/month/:month/:driverid/dashboard',
    name: 'driver-finance',
    component: DriverFinanceDetail
  },
  {
    path: base+'finance/driver/:driverid/transactions',
    name: 'driver-finance-transactions',
    component: DriverTransaction
  },
  {
    path: base+'finance/vendor',
    name: 'vendor',
    component: VendorFinance
  },
  {
    path: base+'finance/vendor/month/:month',
    name: 'vendor-finance-month',
    component: VendorFinanceMonth
  },
  {
    path: base+'finance/vendor-finance-list',
    name: 'vendor-finance-list',
    component: VendorFinanceList
  },
  {
    path: base+'finance/vendor/month/:month/:id/dashboard',
    name: 'restaurant-finance-list',
    component: RestaurantFinance
  },
  {
    path: base+'finance/vendor/:id/transactions',
    name: 'restaurant-transaction-list',
    component: RestaurantFinanceTransaction
  },
  {
    path: base+'category',
    name: 'category-list',
    component: CategoryList
  },
  {
    path: base+'category/add',
    name: 'category-add',
    component: CategoryAdd
  },
  {
    path: base+'category/edit/:category_id',
    name: 'category-edit',
    component: CategoryEdit
  },
  {
    path: base+'category/sub-category/:category_id',
    name: 'sub-category-list',
    component: SubCategoryList
  },
  {
    path: base+'category/sub-category-add/:category_id',
    name: 'sub-category-add',
    component: SubCategoryAdd
  },
  {
    path: base+'category/sub-category-edit/:id',
    name: 'sub-category-edit',
    component: SubCategoryEdit
  },
  {
    path: base+'faq',
    name: 'faq-list',
    component: FaqList
  },
  {
    path: base+'faq/add',
    name: 'faq-add',
    component: FaqAdd
  },
  {
    path: base+'faq/edit/:id',
    name: 'faq-edit',
    component: FaqEdit
  },
  {
    path: base+'system/list',
    name: 'system-list',
    component: SystemList
  },
  {
    path: base+'csv/logs',
    name: 'csv-log',
    component: CsvLogs
  },
  // {
  //   path: base+'cuisines',
  //   name: 'cuisines-list',
  //   component: CuisinesList
  // },
  // {
  //   path: base+'cuisines/add',
  //   name: 'cuisines-add',
  //   component: CuisinesAdd
  // },
  {
    path: base+'invoice/list',
    name: 'InvoiceList',
    component: InvoiceList
  },
  // {
  //   path: base+'cuisines/edit/:cuisine_id',
  //   name: 'cuisines-edit',
  //   component: CuisinesEdit
  // },
  {
    path: base+'settings/configurations',
    name: 'configurations',
    component: Configuration
  },
  {
    path: base+'settings/app-layout-setting',
    name: 'app-layout-setting',
    component: AppLayoutSetting
  },
  {
    path: base+'settings/themes',
    name: 'themes',
    component: Themes
  },
  {
    path: base+'eagle-view/list',
    name: 'eagle-list',
    component: EagleView
  },
  {
    path: base+'content-page',
    name: 'content-list',
    component: ContentPage
  },
  {
    path: base+'reports',
    name: 'reports-list',
    component: Reports
  },
  {
    path: base+'reports/customer_credit_report',
    name: 'reports.customer.credit.report',
    component: CustomerCreditReport
  },
  {
    path: base+'reports/sales_report',
    name: 'reports.sale.report',
    component: SalesReport
  },
  {
    path: base+'reports/customer_report',
    name: 'reports.customer.report',
    component: CustomerReport
  },
  {
    path: base+'reports/total_sales_earning',
    name: 'reports.total.earning',
    component: TotalSaleEarning
  },
  {
    path: base+'reports/tax_report',
    name: 'reports.tax.report',
    component: TaxReport
  },
  {
    path: base+'reports/driver_report',
    name: 'reports.driver.report',
    component: DriverReport
  },
  {
    path: base+'reports/inactive_customer_report',
    name: 'reports.inactive.customer.report',
    component: InactiveCustomerReport
  },
  {
    path: base+'reports/cod_online_order_report',
    name: 'reports.cod.online.order.report',
    component: CODOnlineOrderReport
  },
  {
    path: base+'reports/avg_rating_report',
    name: 'reports.avg.rating.report',
    component: AvgRatingReport
  },
  {
    path: base+'reports/promo_code_report',
    name: 'reports.promo.code.report',
    component: PromoCodeReport
  },
  {
    path: base+'reports/driver_report_details',
    name: 'driver.reports.details',
    component: DriverReportDetailsReport
  },
  {
    path: base+'settings/terminology',
    name: 'terminology-list',
    component: Terminology
  },
  {
    path: base+'profile/subscription_info',
    name: 'subscription-info',
    component: Profile,
    access: true
  },
  {
    path: base+'profile/change-password',
    name: 'change-password',
    component: ChangePassword,
    access: true
  },
  {
    path: base+'profile/business-profile',
    name: 'business-profile',
    component: BusinessProfile,
    access: true
  },
  {
    path: base+'settings/user-access',
    name: 'user-access',
    component: UserAccess,
    access: true
  },
  {
    path: base+'settings/user-access/add',
    name: 'user-access-add',
    component: UserAccessAdd
  },
  {
    path: base+'settings/user-access/:id/edit',
    name: 'user-access-edit',
    component: UserAccessEdit
  },
  {
    path: base+'settings/user-access/:id/permissions',
    name: 'user-access.permissions',
    component: UserAccessPermission
  },
  {
    path: base+'content-page/add',
    name: 'content-page-add',
    component: AddContentPage
  },
  {
    path: base+'content-page/edit/:id',
    name: 'content-page-edit',
    component: EditContentPage
  },
  {
    path: base+'content-page/view/:id',
    name: 'content-page-view',
    component: ViewContentPage
  },
  {
    path: base+'help/list',
    name: 'help',
    component: HelpList,
    access: true
  },
  {
    path: base+'whatsnew',
    name: 'whats-new',
    component: WhatsNew,
    access: true
  },
  {
    path: base+'client',
    name: 'client-list',
    component: ClientList,
    access: true
  },
  {
    path: base+'client/add',
    name: 'client-add',
    component: ClientAdd,
    access: true
  },
  {
    path: base+'client/edit/:vendor_id',
    name: 'client-edit',
    component: ClientEdit,
    access: true
  },
  {
    path: base+'currency',
    name: 'currency-list',
    component: CurrencyList,
    access: true
  },
  {
    path: base+'changelog',
    name: 'change-log',
    component: ChangeLog,
    access: true
  },
  {
    path: base+'reports/vendor_rating_review_report',
    name: 'reports.vendor.rating.review.report',
    component: VendorRatingReviewReport
  },
  {
    path: base+'reports/driver_rating_review_report',
    name: 'reports.driver.rating.review.report',
    component: DriverRatingReviewReport
  },
  {
    path: base+'customer/add',
    name: 'customer-add',
    component: CustomerAdd,
  },

  {
    path: base+'alert',
    name: 'alert-list',
    component: AlertList,
  },
  
  {
    path: base+'supplier/purchasing_price_list',
    name: 'purchasing_price_list',
    component: PurchasingPriceList,
  },
  {
    path: base+'supplier',
    name: 'supplier-list',
    component: SupplierList,
  },
  {
    path: base+'supplier/add',
    name: 'supplier-add',
    component: SupplierAdd,
    access: true
  },
  {
    path: base+'supplier/edit/:id',
    name: 'supplier-edit',
    component: SupplierEdit,
    access: true
  },
  
  {
    path: base+'contact',
    name: 'contacts-list',
    component: ContactsList,
  },
  
  {
    path: base+'contact/add',
    name: 'contact-add',
    component: ContactAdd,
    access: true
  },

  {
    path: base+'contact/edit/:id',
    name: 'contact-edit',
    component: ContactEdit,
    access: true
  },

  {
    path: base+'purchasing_prices',
    name: 'purchasing-prices',
    component: PurchasingPrices,
  },
  {
    path: base+'deal',
    name: 'deal-list',
    component: DealList,
  },
  {
    path: base+'deal/add',
    name: 'deal-add',
    component: DealAdd,
    access: true
  },
  {
    path: base+'product',
    name: 'product-list',
    component: ProductList,
    access: true
  },
  {
    path: base+'product/add',
    name: 'product-add',
    component: ProductAdd,
    access: true
  },
  {
    path: base+'alert/add',
    name: 'alert-add',
    component: AlertAdd,
    access: true
  },
  {
    path: base+'product/edit/:id',
    name: 'product-edit',
    component: ProductEdit,
    access: true
  },
  {
    path: base+'alert/edit/:id',
    name: 'alert-edit',
    component: AlertEdit,
    access: true
  },
  {
    path: base+'deal/edit/:id',
    name: 'deal-edit',
    component: DealEdit,
    access: true
  },
  {
    path: base+'product/sub-product/:product_id',
    name: 'sub-product-list',
    component: SubProductList,
    access: true
  },
  {
    path: base+'sub-product-add/:product_id',
    name: 'sub-product-add',
    component: SubProductAdd,
    access: true
  },
  {
    path: base+'sub-product-order/:product_id',
    name: 'sub-product-order',
    component: SubProductOrder,
    access: true
  },
  {
    path: base+'sub-product-edit/:id',
    name: 'sub-product-edit',
    component: SubProductEdit,
    access: true
  },
  {
    path: base+'subscription',
    name: 'subscription-list',
    component: SubScriptionList,
    access: true
  },
  {
    path: base+'subscription/product/:subscription_id',
    name: 'subscription-product-list',
    component: SubscriptionProductList,
    access: true
  },
  {
    path: base+'product-brand',
    name: 'product-brand-list',
    component: productBrandList,
    access: true
  },
  {
    path: base+'product-brand/add',
    name: 'product-brand-add',
    component: ProductBrandAdd,
    access: true
  },
  {
    path: base+'product-brand/edit/:brand_id',
    name: 'product-brand-edit',
    component: ProductBrandEdit,
    access: true
  },
  {
    path: base+'faq-category',
    name: 'faq-category-list',
    component: FaqCategoryList,
    access: true
  },
  {
    path: base+'faq-category-add',
    name: 'faq-category-add',
    component: FaqCategorAdd,
    access: true
  },
  {
    path: base+'faq-category-edit/:id',
    name: 'faq-category-edit',
    component: FaqCategorEdit,
    access: true
  },
  {
    path: base+'time-slot',
    name: 'time-slot-list',
    component: TimeSlotList,
    access: true
  },
  {
    path: base+'time-slot-add',
    name: 'time-slot-add',
    component: TimeSlotAdd,
    access: true
  },
  {
    path: base+'time-slot-edit/:id',
    name: 'time-slot-edit',
    component: TimeSlotEdit,
    access: true
  },
  {
    path: base+'attribute',
    name: 'attribute-list',
    component: AttributeList,
    access: true
  },
  {
    path: base+'attribute-add',
    name: 'attribute-add',
    component: AttributeAdd,
    access: true
  },
  {
    path: base+'attribute-edit/:id/:type',
    name: 'attribute-edit',
    component: AttributeEdit,
    access: true
  },
  {
    path: base+'order-add',
    name: 'order-add',
    component: OrderAdd,
    access: true
  },
  {
    path: base+'popular-search',
    name: 'popular-search',
    component: PopularSearchList,
    access: true
  },
  {
    path: base+'popular-search-add',
    name: 'popular-search-add',
    component: PopularSearchAdd,
    access: true
  },
  {
    path: base+'popular-search-edit/:id/:type',
    name: 'popular-search-edit',
    component: PopularSearchEdit,
    access: true
  },
  {
    path: base+'producer-company',
    name: 'producer-company-list',
    component: producerCompanyList,
    access: true
  },
  {
    path: base+'producer-company/add',
    name: 'producer-company-add',
    component: producerCompanyAdd,
    access: true
  },
  {
    path: base+'producer-company/edit/:company_id',
    name: 'producer-company-edit',
    component: producerCompanyEdit,
    access: true
  },
  {
    path: base+'producer-brand/:producer_id',
    name: 'producer-brand-list',
    component: producerBrandList,
    access: true
  },
  {
    path: base+'producer-brand/add/:producer_id',
    name: 'producer-brand-add',
    component: producerBrandAdd,
    access: true
  },
  {
    path: base+'producer-brand/edit/:id',
    name: 'producer-brand-edit',
    component: producerBrandEdit,
    access: true
  },
];

const restaurantRoutes = [
  {
    path: '*',
    redirect: base+'login'
  },
  {
    path: base+'vendor/login',
    name: 'vendor.login',
    component: Login
  },
  {
    path: base+'vendor/:vendor_id/signup',
    name: 'vendor.signup',
    component: SubVendorSignup
  },
  {
    path: base+'vendor/dashboard',
    name: 'vendor.dashboard',
    component: Dashboard
  },
  {
      path: base+'vendor/orders/list',
      name: 'vendor.order.list',
      component: Order
  },
  {
    path: base+'vendor/vendors/catalog',
    name: 'vendor.vendor.catalog',
    component: Catalog
  },
  {
    path: base+'vendor/vendors/add-customization/:menu_item_id',
    name: 'vendor.vendor.add.customization',
    component: AddCustomization
  },
  {
    path: base+'vendor/vendors/add-sub-customization/:menu_item_selection_id',
    name: 'vendor.vendor.add.sub.customization',
    component: AddSubCustomization
  },
  {
    path: base+'vendor/coupon/list',
    name: 'vendor.coupon.list',
    component: CouponList
  },
  {
    path: base+'vendor/vendor-discount',
    name: 'vendor.discount',
    component: VendorDiscount
  },
  {
    path: base+'vendor/finance-list',
    name: 'vendor.finance.list',
    component: RestaurantFinance
  },
  {
    path: base+'vendor/reports',
    name: 'vendor.reports.list',
    component: Reports
  },
  {
    path: base+'vendor/reports/sales_report',
    name: 'vendor.reports.sale.report',
    component: SalesReport
  },
  {
    path: base+'vendor/reports/item_report',
    name: 'vendor.reports.item.report',
    component: ItemReport
  },
  {
    path: base+'vendor/profile',
    name: 'vendor.profile',
    component: VendorProfile
  },
  {
    path: base+'vendor/operation-time',
    name: 'vendor.timeslot',
    component: OperationTime
  },
  // {
  //   path: base+'vendor/selling-timeslot',
  //   name: 'vendor.selling.timeslot',
  //   component: SellingTimeSlot
  // },
  {
    path: base+'vendor/vendor-rating',
    name: 'vendor.review',
    component: VendorRating
  },
  {
    path: base+'vendor/vendor-category',
    name: 'vendor.restaurant.category',
    component: VendorCategory
  },
  {
    path: base+'vendor/finance/month',
    name: 'vendor.restaurant.finance.list',
    component: RestaurantFinance
  },
  {
    path: base+'vendor/finance',
    name: 'vendor.finance',
    component: VendorFinance
  },
  {
    path: base+'vendor/forgot-password',
    name: 'forgot-password',
    component: ForgotPassword
  },
]

const router = new Router({
    mode: "history",
    // base,
    routes: [
      ...vendorRoutes,
      ...restaurantRoutes
      // ...resturantRoutes
      
    ],
    scrollBehavior() {
        return {x: 0, y: 0}
    }
  });
  router.beforeEach((to, from, next) => {
    $('body').addClass('sidebar-disable').removeClass('sidebar-enable');
    var noauth = ['login','forgot-password','vendor.login','signup','vendor.signup','change-log'];
    const menu = vendorRoutes.find(u => u.name == to.name);
    const sidemenu = urls.find(u => menu && menu.path.includes(u.link));
    if (!noauth.includes(to.name) ){
      if(!Vue.prototype.$auth || !Vue.prototype.$auth.setting){
        Vue.prototype.$auth.setUser((type)=> {
          if(noauth.includes(type)) next({name: type})
          else {
            if(Vue.prototype.$auth.user.login_type != 'vendor' || menu.access || Vue.prototype.$auth.user.access.some(s => sidemenu.permissions.some(p=>p.includes(s)))){
              next()
            }else{
              error_message('Permission required')
              next({name: from.name});
            }
            // next()
          }
        });
      }
      else {
        if(Vue.prototype.$auth.user.login_type != 'vendor' || menu.access || Vue.prototype.$auth.user.access.some(s => sidemenu.permissions.some(p=>p.includes(s)))){
          next()
        }else{
          error_message('Permission required')
          next({name: from.name});
        }
      }
    } 
    else {
      next()
    }
  });
export default router;